export const defaultColumns = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: {
            compare: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        defaultSortOrder: "ascend"
    }
]